// extracted by mini-css-extract-plugin
export var root = "Credits-module--root--2PPS6";
export var beforeTitle = "Credits-module--beforeTitle--zntAS";
export var title = "Credits-module--title--2D3W4";
export var creditRow = "Credits-module--creditRow--3VNw4";
export var credit = "Credits-module--credit--2UCq4";
export var left = "Credits-module--left--1-fAO";
export var right = "Credits-module--right--Orb8o";